import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { HomePageActivityModel } from '@/models/homePage/activity';
var m = {
  namespaced: true,
  state: {
    nav: '',
    data: null,
    activityList: {},
    memberList: {
      list: [],
      loaded: false,
      requesting: false
    },
    monitorList: {
      list: [],
      loaded: false,
      requesting: false
    },
    teamList: {
      list: [],
      loaded: false,
      requesting: false
    },
    going: [],
    hot: [],
    knowledge: []
  },
  mutations: {
    setNav: function setNav(state, nav) {
      state.nav = nav;
    },
    setData: function setData(state, data) {
      state.data = data;
    },

    /**
     * 活动列表
     */
    setActivityList: function setActivityList(state, _a) {
      var mode = _a.mode,
          list = _a.list;
      Vue.set(state.activityList, mode, list.map(function (item) {
        return new HomePageActivityModel(item);
      }));
    },

    /**
     * 成员列表
     */
    concatMemberList: function concatMemberList(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.memberList.list = state.memberList.list.concat(list);
    },
    setMemberListLoaded: function setMemberListLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.memberList.loaded = loaded;
    },
    setMemberListReq: function setMemberListReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.memberList.requesting = req;
    },

    /**
     * 队长列表
     */
    concatMonitorList: function concatMonitorList(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.monitorList.list = state.monitorList.list.concat(list);
    },
    setMonitorListLoaded: function setMonitorListLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.monitorList.loaded = loaded;
    },
    setMonitorListReq: function setMonitorListReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.monitorList.requesting = req;
    },

    /**
     * 队伍列表
     */
    concatTeamList: function concatTeamList(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.teamList.list = state.teamList.list.concat(list);
    },
    setTeamListLoaded: function setTeamListLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.teamList.loaded = loaded;
    },
    setTeamListReq: function setTeamListReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.teamList.requesting = req;
    },
    setGoing: function setGoing(state, list) {
      state.going = list;
    },
    setHot: function setHot(state, list) {
      state.hot = list;
    },
    setKnowledge: function setKnowledge(state, _a) {
      var offset = _a.offset,
          forceUpdate = _a.forceUpdate,
          list = _a.list,
          count = _a.count;
      list.forEach(function (item, idx) {
        Vue.set(state.knowledge, idx + offset, item);
      });

      if (forceUpdate) {
        state.knowledge = state.knowledge.slice(0, count);
      }
    }
  },
  actions: {
    /**
     * 获取数据
     */
    getData: function getData(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/data')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setData', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 活动列表
     */
    getActivityList: function getActivityList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var mode = _b.mode;
      return __awaiter(this, void 0, void 0, function () {
        var params, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              params = {};

              if (mode && mode !== 'all') {
                Object.assign(params, {
                  mode: mode
                });
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/activity_list', {
                params: params
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setActivityList', {
                  mode: mode,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 成员列表
     */
    getMemberList: function getMemberList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.memberList;

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setMemberListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/member_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatMemberList', {
                  list: list
                });

                if (list.length < count) {
                  commit('setMemberListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setMemberListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 队长列表
     */
    getMonitorList: function getMonitorList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.monitorList;

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setMonitorListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/monitor_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatMonitorList', {
                  list: list
                });

                if (list.length < count) {
                  commit('setMonitorListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setMonitorListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 队伍列表
     */
    getTeamList: function getTeamList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.teamList;

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setTeamListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/team_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatTeamList', {
                  list: list
                });

                if (list.length < count) {
                  commit('setTeamListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setTeamListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getGoing: function getGoing(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/activity/going')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setGoing', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getHot: function getHot(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/activity/hot')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setHot', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getKnowledge: function getKnowledge(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var count = _b.count,
          offset = _b.offset,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/home_page/knowledge', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setKnowledge', {
                  list: rdata.data,
                  forceUpdate: forceUpdate,
                  count: count,
                  offset: offset
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;